import React from 'react';

interface ControllerFieldInputProps {
  name: string;
  placeholder: string;
  value: string;
  type?: string;
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleFocus: (event: React.FocusEvent<HTMLInputElement>) => void;
  error?: string;
  helpText?: string;
}

const ControllerFieldInput = ({
  name,
  placeholder,
  value,
  type = 'text',
  handleChange,
  handleFocus,
  error,
  helpText,
}: ControllerFieldInputProps) => (
  <div className="auth-input-group">
    <input
      type={type}
      id={name}
      className="auth-input"
      name={name}
      placeholder={placeholder}
      value={value}
      onChange={handleChange}
      onFocus={handleFocus}
    />
    {error && (
      <p className="auth-input-error">
        {error}
      </p>
    )}
    {helpText && (
      <div className="text-helper">
        {helpText}
      </div>
    )}
  </div>
);

export default ControllerFieldInput;
